export default __webpack_public_path__ + "fonts/07ff5c3a24dfbd43d4b23ef445bf2c40-slkscre.ttf";